import { getEnvVar } from '@mc/client-env'
import { GladlyAnswerIndex } from '../../utils'

export const helpCenterApi = {
  search: (audience: string, query: string, language: string) =>
    `${getEnvVar('GLADLY_API_URL')}/api/v1/orgs/${getEnvVar('GLADLY_ORG_ID')}/answers-search?q=${encodeURIComponent(query)}&audienceId=${audience}&lng=${language}`,
}

export const searchGladlySupportAnswers = async (
  audienceId: string,
  searchQuery: string,
  lng: string,
) => {
  const searchAnswers = async () =>
    (await (
      await fetch(helpCenterApi.search(audienceId, searchQuery, lng))
    ).json()) as unknown as Promise<GladlyAnswerIndex[]>

  try {
    const results = await searchAnswers()

    return {
      results,
    }
  } catch (e) {
    return {
      error: e,
      results: null,
    }
  }
}
